import type { SortersType } from '@lumapps/lumx-filter-and-sort/types';
import { DOCUMENT_V1_SORTING } from '@lumapps/medias-document/constants';

import { FILE_PICKER } from './keys';

export const FILE_PICKER_SORTING_FIELDS: SortersType[] = [
    { id: DOCUMENT_V1_SORTING.CREATED_ASC, label: FILE_PICKER.LAST_CREATED },
];

export const PDF_PICKER_SORTING_FIELDS: SortersType[] = [
    { id: DOCUMENT_V1_SORTING.CREATED_ASC, label: FILE_PICKER.LAST_CREATED },
];
